/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIEmployeeAutocompleteSuggestion
 */
export interface APIEmployeeAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeAutocompleteSuggestion
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeAutocompleteSuggestion
     */
    userEmail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIEmployeeAutocompleteSuggestion
     */
    workShiftNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIEmployeeAutocompleteSuggestion
     */
    groupNames?: Array<string>;
}

/**
 * Check if a given object implements the APIEmployeeAutocompleteSuggestion interface.
 */
export function instanceOfAPIEmployeeAutocompleteSuggestion(value: object): value is APIEmployeeAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIEmployeeAutocompleteSuggestionFromJSON(json: any): APIEmployeeAutocompleteSuggestion {
    return APIEmployeeAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIEmployeeAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIEmployeeAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'userEmail': json['user_email'] == null ? undefined : json['user_email'],
        'workShiftNames': json['work_shift_names'] == null ? undefined : json['work_shift_names'],
        'groupNames': json['group_names'] == null ? undefined : json['group_names'],
    };
}

export function APIEmployeeAutocompleteSuggestionToJSON(value?: APIEmployeeAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'user_email': value['userEmail'],
        'work_shift_names': value['workShiftNames'],
        'group_names': value['groupNames'],
    };
}

